import Modal from 'components/modal/modalComponent';
import { ModalButtonProps } from 'components/modal/modal.interfaces';
import { useGetGenericActions } from 'hooks/useGetGenericActions';
import { genericActionsIds } from 'utilities/constants';
import { Notification } from 'app/dashboard/interfaces/notifications.interfaces';
import { replaceTokensToDate, sanitize } from 'utilities/sanitizer';
import React from 'react';

interface NotificationsModalProps {
  handleClose: () => void;
  notification: Notification;
}

export const NotificationsModal: React.FC<NotificationsModalProps> = ({
  handleClose,
  notification,
}) => {
  const { data: genericAction, loading: genericActionLoading } =
    useGetGenericActions({
      locale: 'en',
      genericActionId: [
        genericActionsIds.CANCEL,
        genericActionsIds.SUBMIT,
        genericActionsIds.CLOSE,
        genericActionsIds.BACK,
      ],
    });

  const buttons: ModalButtonProps[] = [
    {
      label: genericAction?.[genericActionsIds.CLOSE].close,
      disabled: false,
      onClick: handleClose,
      testID: 'close',
    },
  ];

  const text = replaceTokensToDate(
    notification.message,
    notification.constants,
  );

  if (genericActionLoading && !genericAction) return null;

  return (
    <Modal
      isOpen={true}
      title={replaceTokensToDate(notification.title, notification.constants)}
      modalDesktopWidth="desktop:max-w-[1120px]"
      buttons={buttons}
      onClose={handleClose}
      enableOverlapOfModals={true}
    >
      <div className="text-med-gray-3 notification-item">
        <p dangerouslySetInnerHTML={{ __html: sanitize(text as string) }} />
      </div>
    </Modal>
  );
};
